export default __webpack_public_path__ + "static/media/PlasticMoldingImg1.2105021e.jpg";